module.exports = __webpack_public_path__ + "img/appti.dc6a6aac.png";